import { render, staticRenderFns } from "./TextStub.vue?vue&type=template&id=46dcefad&"
import script from "./TextStub.vue?vue&type=script&lang=js&"
export * from "./TextStub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports